import React, { useEffect } from "react";
import { getAllRadiologyReport } from "../../../../../store/slices/radiologyReport";
import { useDispatch, useSelector } from "react-redux";

const ReportDetails = () => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { radiologyReports } = useSelector((state) => state.radiologyReport);
  const radiologyReportId = sessionStorage.getItem("radiologyReportId");
  const newRadiologyReports = radiologyReports[0];
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getAllRadiologyReport({ clinicId, reportId: radiologyReportId, token }),
    );
  }, [dispatch, clinicId, radiologyReportId, token]);


  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Report Details</h4>
        <div className="row">
          <div className="col-xl-4">
            <p>Name</p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.patientId?.userId?.name}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Appointment Date</p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.appDate
                ? new Date(newRadiologyReports.appDate)
                    .toISOString()
                    .split("T")[0]
                : ""}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Appointment Id</p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.appointmentId}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Age </p>
            <p className="border p-1 ps-3">
              {`${newRadiologyReports?.patientId?.userId?.age?.year} Y` ||
                `${newRadiologyReports?.patientId?.userId?.age?.month} M` ||
                `${newRadiologyReports?.patientId?.userId?.age?.day}`}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Gender </p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.patientId?.userId?.gender}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Service Mode</p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.serviceMode}
            </p>
          </div>
          <div className="col-xl-4">
            <p>Radiology Service</p>
            <p className="border p-1 ps-3">
              {newRadiologyReports?.radiologyServiceInfo?.serviceName}
            </p>
          </div>
          <div className="col-xl-8">
            <p>Radiology Service Detail</p>
            <p className="border p-1 ps-3">
              {[
                ...(newRadiologyReports?.radiologyServiceInfo?.serviceDetails?.map(
                  (test) => test.serviceDetailsName,
                ) || []),
              ].join(", ")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
